import { useState } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material"
import MedicationSortForm from "../MedicationSortForm";
import { BiSortAlt2 } from "react-icons/bi";

const MedicationSortDropdown = ({ setOpenSortNav }) => {
  const sm = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const [showDropdown, setShowDropdown] = useState(false)

  const handleClickSort = () => {
    if (!sm) {
      setShowDropdown(!showDropdown)
    } else {
      setOpenSortNav(true)
    }
  }

  return (
    <Box
      sx={{
        position: 'relative'
      }}
    >
      <Box
        sx={{
          minWidth: '48px',
          height: '40px',
          borderRadius: '8px',
          border: '1px solid',
          borderColor: "primary.mediumGray",
          bgcolor: 'white',
          boxShadow: '0px 2px 10px 0px #5B87EF33',
          ml: '8px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '8px 12px'
        }}
        onClick={handleClickSort}
      >
        <BiSortAlt2
          size='20px'
        />
        <Typography variant="body">Sort</Typography>
      </Box>
      <Box
        sx={{
          display: { xs: 'none', md: showDropdown ? 'block' : 'none' },
          position: 'absolute',
          top: '50px',
          right: 0,
          bgcolor: 'white',
          borderRadius: '16px',
          maxWidth: '390px',
          boxShadow: '0px 2px 20px 0px #5B87EF66',
          padding: '24px',
          zIndex: '10'
        }}
      >
        <MedicationSortForm onClose={() => setShowDropdown(false)} />
      </Box>
    </Box>
  )
}

export default MedicationSortDropdown